import setting from './setting'

export default [...setting]
